export default __webpack_public_path__ + "static/new2-f2588778bf3a050abecefdc02d5a3c3a.png";